import React, { useState, useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';
import Skeleton from '../../../../components/Skeleton';
import TableTemplate from '../../../../components/table/index';
import { getAllScreeningLog } from '../../../../controllers/ScreeningLogController';

const TableComponent = ({ t }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    
    const columns = useMemo(() => [
        { field: 'name', title: t('common.name.title'), sortable: true },
        { field: 'score', title: t('common.score'), sortable: true },
        { field: 'classification', title: t('common.classification.title'), sortable: true },
        { field: 'created_at', title: t('common.created.title'), sortable: true },
    ], [t]);
    
    const actions = useMemo(() => [], []);
    
    const filters = useMemo(() => [
        { field: 'classification', label: t('common.classification.title'), by: t('common.classification.good'), labelBy: t('common.classification.good'), mode: 'exact' },
        { field: 'classification', label: t('common.classification.title'), by: t('common.classification.mildAnxiety'), labelBy: t('common.classification.mildAnxiety'), mode: 'exact' },
        { field: 'classification', label: t('common.classification.title'), by: t('common.classification.moderateAnxiety'), labelBy: t('common.classification.moderateAnxiety'), mode: 'exact' },
        { field: 'classification', label: t('common.classification.title'), by: t('common.classification.severeAnxiety'), labelBy: t('common.classification.severeAnxiety'), mode: 'exact' },
    ], [t]);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                
                const result = await getAllScreeningLog();
                const formattedRows = result.screening_log.map((screeningLog) => {
                    const formattedClassification = screeningLog.classification.toLowerCase().replace(/\s(.)/g, (match) => match.toUpperCase()).replace(/\s/g, '');
                    const translatedClassification = t(`common.classification.${formattedClassification}`, { defaultValue: screeningLog.classification });
                    
                    return {
                        id: screeningLog.id,
                        name: screeningLog.name,
                        score: screeningLog.score,
                        classification: translatedClassification,
                        created_at: screeningLog.created_at
                    }
                });
                
                setRows(formattedRows);
            } catch (error) {
                toast.error(error.message);
            } finally {
                setLoading(false);
            };
        };
        
        fetchData();
    }, [t]);
    
    if (loading) {
        return (
            <Skeleton className='h-96 w-full rounded-lg' />
        );
    };
    
    return (
        <div>
            <TableTemplate
                rows={rows}
                columns={columns}
                actions={actions}
                filters={filters}
                fileName={t('menu.screeningLog')}
            />
        </div>
    );
};

export default TableComponent;
